<app-form-field
  [label]="label"
  [required]="required"
  [control]="control"
  [submitted]="submitted"
  [errorMessages]="errorMessages"
  actionVerb="Upload"
>
  <input
    class="form-control"
    type="file"
    [class.is-invalid]="isInvalid"
    [accept]="accept"
    (change)="fileChange.emit($event)"
  />
  <div *ngIf="uploadedFileName" class="text-success small mt-1 d-flex align-items-center gap-2">
    <span><i class="feather icon-check-circle"></i> {{ uploadedFileName }}</span>
    <a href="javascript:void(0)" (click)="view.emit()">View</a>
    <a href="javascript:void(0)" class="text-danger" (click)="remove.emit()">Remove</a>
  </div>
</app-form-field>
